<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{pageData.MenuName}}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>代碼類別</td>
                  <td>
                    <select v-model="form.code">
                      <option
                        v-for="(data, index) in dropDownList.codes"
                        :key="index"
                        :value="data.codeid"
                      >
                        {{ data.codename }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>代碼種類</td>
                  <td>
                    <p>
                      <label>
                        <input type="radio" value="" v-model="form.codeType" />
                        全部</label
                      >
                      <label>
                        <input
                          type="radio"
                          style="margin-left: 5px"
                          value="Share"
                          v-model="form.codeType"
                        />
                        共用代碼</label
                      >
                      <label>
                        <input
                          type="radio"
                          style="margin-left: 5px"
                          value="Pdis"
                          v-model="form.codeType"
                        />
                        法務部專用</label
                      >
                      <label>
                        <input
                          type="radio"
                          style="margin-left: 5px"
                          value="Cy"
                          v-model="form.codeType"
                        />
                        監察院專用</label
                      >
                      <br />
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>啟用註記</td>
                  <td>
                    <p>
                      <label>
                        <input type="radio" value="" v-model="form.disableMk" />
                        全部
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="N"
                          v-model="form.disableMk"
                        />
                        啟用
                      </label>
                      <label>
                        <input
                          type="radio"
                          style="margin-left: 5px"
                          value="Y"
                          v-model="form.disableMk"
                        />
                        停用
                      </label>
                      <br />
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="doQuery()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="新增"
                          @click="btnAdd()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnModalClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tr>
              <td v-if="grid.paginaiton" align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="form.currentpage = grid.paginaiton.pageNo - 1"
                  v-show="grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                  "
                  @click="form.currentpage = parseInt(data)"
                >
                  {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                  @click="form.currentpage = grid.paginaiton.pageNo + 1"
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="form.pagesize"
                  size="2"
                  maxlength="4"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="form.currentpage"
                  size="2"
                  maxlength="4"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ grid.paginaiton.totalPage }} 頁
                {{ grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th>類別代碼</th>
                    <th>類別名稱</th>
                    <th>代碼種類</th>
                    <th>啟用註記</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="submit"
                        class="btn"
                        value="編"
                        @click="btnEdit(data)"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="submit"
                        class="btn"
                        value="刪"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnDelete(data)"
                      />
                    </td>
                    <td>{{ data.codeid }}</td>
                    <td>{{ data.codename }}</td>
                    <td>{{ data.codetype }}</td>
                    <td>{{ data.disablemk }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <AddModal
      v-model="addModal.show"
      :title="addModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td>代碼類別代碼</td>
              <td><input type="text" v-model="addModal.form.codeId" /></td>
            </tr>
            <tr>
              <td>代碼類別名稱</td>
              <td>
                <input
                  v-model="addModal.form.codeName"
                  size="40"
                  maxlength="40"
                />
              </td>
            </tr>
            <tr>
              <td>代碼種類</td>
              <td>
                <p>
                  <label>
                    <input
                      type="radio"
                      value="Share"
                      v-model="addModal.form.codeType"
                    />
                    共用代碼</label
                  >
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Pdis"
                      v-model="addModal.form.codeType"
                    />
                    法務部專用</label
                  >
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Cy"
                      v-model="addModal.form.codeType"
                    />
                    監察院專用</label
                  >
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td>啟用註記</td>
              <td>
                <p>
                  <label>
                    <input
                      type="radio"
                      value="N"
                      v-model="addModal.form.disableMk"
                    />
                    啟用
                  </label>
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Y"
                      v-model="addModal.form.disableMk"
                    />
                    停用
                  </label>
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnAddModalSave()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="btnAddModalClear()"
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddModal>

    <EditModal
      v-model="editModal.show"
      :title="editModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td>代碼類別代碼</td>
              <td>
                <input
                  type="text"
                  disabled="disabled"
                  v-model="editModal.form.codeId"
                />
              </td>
            </tr>
            <tr>
              <td>代碼類別名稱</td>
              <td>
                <input
                  type="text"
                  size="40"
                  maxlength="40"
                  v-model="editModal.form.codeName"
                />
              </td>
            </tr>
            <tr>
              <td>代碼種類</td>
              <td>
                <p>
                  <label>
                    <input
                      type="radio"
                      name="RadioGroup2"
                      value=""
                      id="RadioGroup2_0"
                      v-model="editModal.form.codeType"
                    />
                    全部</label
                  >
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Share"
                      v-model="editModal.form.codeType"
                    />
                    共用代碼</label
                  >
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Pdis"
                      v-model="editModal.form.codeType"
                    />
                    法務部專用</label
                  >
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Cy"
                      v-model="editModal.form.codeType"
                    />
                    監察院專用</label
                  >
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td>啟用註記</td>
              <td>
                <p>
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="N"
                      v-model="editModal.form.disableMk"
                    />
                    啟用
                  </label>
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Y"
                      v-model="editModal.form.disableMk"
                    />
                    停用
                  </label>
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnEditModalSave()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增細項代碼"
                      @click="btnEditModalAdd(editModal.form, 'I', '')"
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
      <!-- 查詢結果開始-->
      <div class="information" v-if="editModal.form.grid">
        <table width="100%">
          <tbody>
            <tr v-if="editModal.form.grid.paginaiton">
              <td align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="
                    editModal.form.currentpage =
                      editModal.form.grid.paginaiton.pageNo - 1
                  "
                  v-show="editModal.form.grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in editModal.form.grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    editModal.form.grid.paginaiton.pageNo == data
                      ? 'color:red'
                      : 'color:black'
                  "
                  @click="editModal.form.currentpage = parseInt(data)"
                >
                  {{
                    editModal.form.grid.paginaiton.pageNo == data
                      ? "[" + data + "]"
                      : data
                  }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="
                    editModal.form.grid.paginaiton.pageNo <
                    editModal.form.grid.paginaiton.totalPage
                  "
                  @click="
                    editModal.form.currentpage =
                      editModal.form.grid.paginaiton.pageNo + 1
                  "
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="editModal.form.pagesize"
                  size="2"
                  maxlength="4"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="editModal.form.currentpage"
                  size="2"
                  maxlength="4"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ editModal.form.grid.paginaiton.totalPage }} 頁
                {{ editModal.form.grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th colspan="2">操作</th>
                  <th>代碼</th>
                  <th>代碼名稱</th>
                  <th>
                    <p>介接PRDS/DIPT</p>
                    <p>代碼對</p>
                  </th>
                  <th width="20%">
                    <p>選單是</p>
                    <p>否顯示</p>
                  </th>
                  <th>備註</th>
                </tr>
              </thead>
              <tbody v-if="editModal.form.grid">
                <tr
                  v-for="(data, index) in editModal.form.grid.gridDatas"
                  :key="index"
                >
                  <td width="1%" align="center">
                    <input
                      type="submit"
                      class="btn"
                      value="編"
                      data-toggle="modal"
                      data-target=".bs-example-modal-lg"
                      @click="btnEditModalAdd(editModal.form, 'U', data)"
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="刪"
                      data-toggle="modal"
                      data-target=".bs-example-modal-lg"
                      @click="btnEditModalDelete(data)"
                    />
                  </td>
                  <td>{{ data.mcode }}</td>
                  <td>{{ data.mvalue }}</td>
                  <td>{{ data.diptcode }}</td>
                  <td>{{ data.disablemk }}</td>
                  <td>{{ data.rmk }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </EditModal>

    <AddDetailModal
      v-model="addDetailModal.show"
      :title="addDetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td>代碼類別代碼</td>
              <td colspan="3">
                <input
                  type="text"
                  disabled="disabled"
                  v-model="addDetailModal.form.codeId"
                />
              </td>
            </tr>
            <tr>
              <td>代碼類別名稱</td>
              <td colspan="3">
                <input
                  type="text"
                  disabled="disabled"
                  v-model="addDetailModal.form.codeName"
                />
              </td>
            </tr>
            <tr>
              <td>代碼</td>
              <td colspan="3">
                <input
                  type="text"
                  :disabled="addDetailModal.form.SaveType == 'U'"
                  v-model="addDetailModal.form.mcode"
                />
              </td>
            </tr>
            <tr>
              <td>代碼名稱</td>
              <td colspan="3">
                <input
                  type="text"
                  size="40"
                  maxlength="40"
                  v-model="addDetailModal.form.mvalue"
                />
              </td>
            </tr>
            <tr>
              <td>介接PRDS/DIPT代碼對照</td>
              <td>
                <input type="text" v-model="addDetailModal.form.diptCode" />
              </td>
            </tr>
            <tr>
              <td>選單是否顯示</td>
              <td>
                <p>
                  <label>
                    <input
                      type="radio"
                      value="N"
                      v-model="addDetailModal.form.disableMk"
                    />
                    顯示</label
                  >
                  <label>
                    <input
                      type="radio"
                      style="margin-left: 5px"
                      value="Y"
                      v-model="addDetailModal.form.disableMk"
                    />
                    不顯示</label
                  >
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td>備註</td>
              <td>
                <p>
                    <textarea rows="10" cols="70"
                      type="radio"
                      value="N"
                      v-model="addDetailModal.form.rmk"
                    >
                    </textarea>
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="6" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnAddDetailModalSave()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      :disabled="addDetailModal.form.SaveType == 'U'"
                      @click="btnAddDetailModalClear()"
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddDetailModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <AlertDelete v-model="AlertDelete.show" :title="AlertDelete.title">
      <div style="text-align: center">
        <div>是否確定刪除</div>
        <div>
          <button class="btn" @click="AlertDelete.BtnYesConfirm">是</button>
          <button class="btn" @click="AlertDelete.BtnNoConfirm">否</button>
        </div>
      </div>
    </AlertDelete>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex ,getMenu, logOut} from "@/config/util.js";
import {
  S101_GetCodeMetadef,
  S101_SearchCodeMetadefGrid,
  S101_InsertCodeMetadef,
  S101_DeleteCodeMetadef,
  S101_SearchCodeMainGrid,
  S101_UpdateCodeMetadef,
  S101_InsertCodeMain,
  S101_UpdateCodeMain,
  S101_DeleteCodeMain,
} from "@/service/api.js";
export default {
  name: "S101",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S101",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        code: "",
        codeType: "",
        disableMk: "",
        currentpage: 1,
        pagesize: 10,
      },
      dropDownList: {
        codes: [],
      },
      grid: [],
      addModal: {
        show: false,
        title: "S101代碼維護-編輯",
        form: {
          codeId: "",
          codeName: "",
          codeType: "",
          disableMk: "",
        },
      },
      editModal: {
        show: false,
        title: "S101代碼維護-編輯",
        form: {
          codeId: "",
          codeName: "",
          codeType: "",
          disableMk: "",
          pkno: "",
          currentpage: 1,
          pagesize: 10,
        },
        preData: {},
      },
      addDetailModal: {
        show: false,
        title: "S101代碼維護-編輯",
        form: {
          codeId: "",
          codeName: "",
          mcode: "",
          mvalue: "",
          diptCode: "",
          disableMk: "",
          SaveType: "",
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertDelete: {
        show: false,
        title: "系統訊息",
        BtnYesConfirm: function () {
          this.show = false;
        },
        BtnNoConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    AlertDelete: VueModal,
    AddModal: VueModal,
    AddDetailModal: VueModal,
    EditModal: VueModal,
  },
  methods: {
    getCodeDropDownList: function () {
      const self = this;
      S101_GetCodeMetadef({}).then((rData) => {
        self.dropDownList.codes = rData.returnObject;
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //查詢
    doQuery: function (data) {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        codeid: self.form.code,
        codeType: self.form.codeType,
        disableMk: self.form.disableMk,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S101_SearchCodeMetadefGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //新增
    btnAdd: function () {
      const self = this;
      self.btnAddModalClear();
      self.addModal.show = true;
    },
    //第一頁按紐編
    btnEdit: function (data) {
      const self = this;
      self.editModal.preData = data;
      self.editModal.form.pagesize = 10;
      self.editModal.form.currentpage = 1;
      self.SearchCodeMainGrid();
    },
    SearchCodeMainGrid: function () {
      const self = this;
      self.editModal.show = false;
      if (
        !self.checkPage(
          self.editModal.form.currentpage,
          self.editModal.form.pagesize
        )
      )
        return;
      let postData = {
        CODEID: self.editModal.preData.codeid,
        CURRENTPAGE: self.editModal.form.currentpage,
        PAGESIZE: self.editModal.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      console.log(JSON.stringify(postData));
      S101_SearchCodeMainGrid(postData).then((rData) => {
        self.editModal.form.codeId = self.editModal.preData.codeid;
        self.editModal.form.codeName = self.editModal.preData.codename;
        self.editModal.form.codeType =
          self.editModal.preData.codetype == "共用"
            ? "Share"
            : self.editModal.preData.codetype == "法務部專用"
            ? "Pdis"
            : self.editModal.preData.codetype == "監察院專用"
            ? "Cy"
            : "";
        self.editModal.form.disableMk =
          self.editModal.preData.disablemk == "啟用" ? "N" : "Y";
        self.editModal.form.pkno = self.editModal.preData.pkno;
        self.editModal.form.grid = rData.returnObject;
        self.editModal.show = true;
      });
    },
    //第一頁重填
    btnModalClear: function () {
      const self = this;
      self.form.code = "";
      self.form.codeType = "";
      self.form.disableMk = "";
      self.form.currentpage = 1;
      self.form.pagesize = 10;
    },
    //新增頁面存檔
    btnAddModalSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.addModal.form.codeId.trim() == "") {
        errorMsg.push("請填寫代碼類別代碼");
      }

      if (self.addModal.form.codeName.trim() == "") {
        errorMsg.push("請填寫代碼類別名稱");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      let postData = {
        codeId: self.addModal.form.codeId,
        codeName: self.addModal.form.codeName,
        codeType: self.addModal.form.codeType,
        disableMk: self.addModal.form.disableMk,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "新增頁面存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S101_InsertCodeMetadef(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.addModal.show = false;
            self.getCodeDropDownList();
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //新增頁面重填
    btnAddModalClear: function () {
      const self = this;
      self.addModal.form.codeId = "";
      self.addModal.form.codeName = "";
      self.addModal.form.codeType = "Share";
      self.addModal.form.disableMk = "N";
    },
    //第一頁刪除
    btnDelete: function (data) {
      const self = this;
      self.AlertDelete.show = true;
      self.AlertDelete.BtnYesConfirm = () => {
        let errorMsg = [];
        let postData = {
          PKNO: String(data.pkno),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第一頁刪除",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S101_DeleteCodeMetadef(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            errorMsg.push("刪除成功");
            self.Alert.txt = errorMsg;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.addModal.show = false;
              self.getCodeDropDownList();
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            errorMsg.push("刪除失敗");
            self.Alert.txt = errorMsg;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
        self.AlertDelete.show = false;
      };
      self.AlertDelete.BtnNoConfirm = () => {
        self.AlertDelete.show = false;
      };
    },
    //第二頁存檔
    btnEditModalSave: function () {
      const self = this;
      var errorMsg = [];
      if (self.editModal.form.codeId.trim() == "") {
        errorMsg.push("請填寫代碼類別代碼");
      }

      if (self.editModal.form.codeName.trim() == "") {
        errorMsg.push("請填寫代碼類別名稱");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }
      let postData = {
        codeId: self.editModal.form.codeId,
        codeName: self.editModal.form.codeName,
        codeType: self.editModal.form.codeType,
        disableMk: self.editModal.form.disableMk,
        pkno: String(self.editModal.form.pkno),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      S101_UpdateCodeMetadef(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁刪除
    btnEditModalDelete: function (data) {
      const self = this;
      self.AlertDelete.show = true;
      self.AlertDelete.BtnYesConfirm = () => {
        let postData = {
          pkno: String(data.pkno),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁刪除",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S101_DeleteCodeMain(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["刪除成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              let intialData = {
                codeid: self.editModal.form.codeId,
                codename: self.editModal.form.codeName,
                codetype:
                  self.editModal.form.codeType == "Share"
                    ? "共用"
                    : self.editModal.form.codeType == "Pdis"
                    ? "法務部專用"
                    : self.editModal.form.codeType == "Cy"
                    ? "監察院專用"
                    : "",
                disablemk:
                  self.editModal.form.disableMk == "N" ? "啟用" : "停用",
                pkno: self.editModal.form.pkno,
              };
              self.editModal.show = false;
              self.btnEdit(intialData);
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["刪除失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
        self.AlertDelete.show = false;
      };
      self.AlertDelete.BtnNoConfirm = () => {
        self.AlertDelete.show = false;
      };
    },
    //第二頁新增細項代碼
    btnEditModalAdd: function (data, type, grid) {
      const self = this;
      self.addDetailModal.form.SaveType = type;
      if (type == "I") {
        self.addDetailModal.form.codeId = data.codeId;
        self.addDetailModal.form.codeName = data.codeName;
        self.addDetailModal.form.mcode = "";
        self.addDetailModal.form.mvalue = "";
        self.addDetailModal.form.diptCode = "";
        self.addDetailModal.form.disableMk = "";
        self.addDetailModal.form.rmk = "";
        self.addDetailModal.show = true;
      }
      if (type == "U") {
        self.addDetailModal.form.codeId = data.codeId;
        self.addDetailModal.form.codeName = data.codeName;
        self.addDetailModal.form.mcode = grid.mcode;
        self.addDetailModal.form.mvalue = grid.mvalue;
        self.addDetailModal.form.diptCode = grid.diptcode;
        self.addDetailModal.form.disableMk =
          grid.disablemk == "顯示" ? "N" : "Y";
        self.addDetailModal.form.pkno = grid.pkno;
        self.addDetailModal.form.rmk = grid.rmk;
        self.addDetailModal.show = true;
      }
    },
    //第三頁存檔
    btnAddDetailModalSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.addDetailModal.form.mcode.trim() == "") {
        errorMsg.push("請填寫代碼");
      }

      if (self.addDetailModal.form.mvalue.trim() == "") {
        errorMsg.push("請填寫代碼名稱");
      }

      if (self.addDetailModal.form.disableMk == "") {
        errorMsg.push("請勾選選單是否顯示");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      if (self.addDetailModal.form.SaveType == "I") {
        let postData = {
          CODEID: self.addDetailModal.form.codeId,
          MCODE: self.addDetailModal.form.mcode,
          MVALUE: self.addDetailModal.form.mvalue,
          DIPTCODE: self.addDetailModal.form.diptCode,
          DISABLEMK: self.addDetailModal.form.disableMk,
          RMK: self.addDetailModal.form.rmk,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第三頁新增",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        Object.keys(postData).map(
          (k) =>
            (postData[k] =
              typeof postData[k] == "string" ? postData[k].trim() : postData[k])
        );
        S101_InsertCodeMain(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              let intialData = {
                codeid: self.editModal.form.codeId,
                codename: self.editModal.form.codeName,
                codetype:
                  self.editModal.form.codeType == "Share"
                    ? "共用"
                    : self.editModal.form.codeType == "Pdis"
                    ? "法務部專用"
                    : self.editModal.form.codeType == "Cy"
                    ? "監察院專用"
                    : "",
                disablemk:
                  self.editModal.form.disableMk == "N" ? "啟用" : "停用",
                pkno: self.editModal.form.pkno,
              };
              self.editModal.show = false;
              self.btnEdit(intialData);
              self.addDetailModal.show = false;
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
          self.btnAddDetailModalClear();
        });
      }

      if (self.addDetailModal.form.SaveType == "U") {
        let postData = {
          CODEID: self.addDetailModal.form.codeId,
          MCODE: self.addDetailModal.form.mcode,
          MVALUE: self.addDetailModal.form.mvalue,
          DIPTCODE: self.addDetailModal.form.diptCode,
          DISABLEMK: self.addDetailModal.form.disableMk,
          RMK: self.addDetailModal.form.rmk,
          PKNO: String(self.addDetailModal.form.pkno),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第三頁存檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        Object.keys(postData).map(
          (k) =>
            (postData[k] =
              typeof postData[k] == "string" ? postData[k].trim() : postData[k])
        );
        S101_UpdateCodeMain(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              let intialData = {
                codeid: self.editModal.form.codeId,
                codename: self.editModal.form.codeName,
                codetype:
                  self.editModal.form.codeType == "Share"
                    ? "共用"
                    : self.editModal.form.codeType == "Pdis"
                    ? "法務部專用"
                    : self.editModal.form.codeType == "Cy"
                    ? "監察院專用"
                    : "",
                disablemk:
                  self.editModal.form.disableMk == "N" ? "啟用" : "停用",
                pkno: self.editModal.form.pkno,
              };
              self.editModal.show = false;
              self.btnEdit(intialData);
              self.addDetailModal.show = false;
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = rData.messages;
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
          self.btnAddDetailModalClear();
        });
      }
    },
    //第三頁重填
    btnAddDetailModalClear: function () {
      const self = this;
      self.addDetailModal.form.mcode = "";
      self.addDetailModal.form.mvalue = "";
      self.addDetailModal.form.diptCode = "";
      self.addDetailModal.form.disableMk = "";
      self.addDetailModal.form.rmk = "";
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.getCodeDropDownList();
    //self.doQuery();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "editModal.form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.SearchCodeMainGrid();
      }
    },
    "editModal.form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.SearchCodeMainGrid();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
